import React from "react";
import { Platform, StyleSheet, View, Text } from "react-native";
import AppTheme from "../../AppTheme";
import IntegrationsHelper from "../IntegrationsHelper";
import IntegrationWrapper from "./IntegrationWrapper";

export default function ChunkedIntegrationsSection({
  controller,
  integrations,
  title,
  isCollapsed = false,
  onLongPress = () => {},
  expandContainer = () => {},
}) {
  const groupIntegrations = IntegrationsHelper.groupIntegrations(integrations);

  return (
    <View style={styles.section}>
      {title ? <Text style={styles.sectionText}>{title}</Text> : null}
      {groupIntegrations.map((integ, index) => (
        <IntegrationWrapper
          key={index}
          controller={controller}
          data={integ}
          style={styles.item}
          showHours
          isCollapsed={isCollapsed}
          onLongPress={() => onLongPress(integ)}
          onContainerPress={expandContainer}
        />
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  section: {
    borderBottomColor: AppTheme.borderColor,
    borderBottomWidth: 1,
  },
  sectionText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#8B92A1",
    marginTop: 8,
    marginLeft: 9,
  },
  item: {
    marginTop: 6,
    //marginBottom: 6,
    paddingBottom: 0,
    height: "auto",
  },
});
